'use client';

import { isBrowser } from '@lib/environment/isBrowser';
import { Button } from '../Clickables/Buttons/Button';

export const CookiePreferencesLink = () => {
  return (
    <Button
      aria-label="cookie-preferences"
      onClick={() => {
        if (isBrowser()) {
          window.Osano?.cm?.showDrawer();
        }
      }}
      variant="textDeprecatedLight"
      className="body-text-md"
    >
      Cookie Preferences
    </Button>
  );
};
